import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollElement = document.scrollingElement || document.documentElement;

    // Check if browser supports smooth behavior
    if ("scrollBehavior" in document.documentElement.style) {
      scrollElement.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Fallback for older browsers
      scrollElement.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
